import React from "react";
import { RiUser3Fill, RiMailFill, RiPhoneFill, RiShieldUserFill, RiLogoutBoxRLine } from "react-icons/ri";
import useAuth from "../useAuth";
import { Card } from "@mui/material";

export const ProfilePage = () => {
  const { user, logout } = useAuth();

  console.log("User object:", user);

  // Handle nested data structure
  const userData = user?.data || user;
  console.log("User data:", userData);

  return (
    <div className="p-6 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-slate-800 mb-6">Profile</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Profile Card */}
          <div className="lg:col-span-2">
            <Card sx={{ borderRadius: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.05)", p: 4 }}>
              <div className="flex items-start gap-6 mb-6">
                <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                  {userData?.name?.charAt(0)?.toUpperCase() || "U"}
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-slate-800">{userData?.name || "User"}</h2>
                  <p className="text-slate-500 mt-1">@{userData?.userName?.split("@")[0] || "username"}</p>
                  <div className="mt-3">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 border border-blue-200 capitalize">
                      {userData?.role || "User"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-4 pt-4 border-t border-slate-200">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                    <RiUser3Fill className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Full Name</p>
                    <p className="font-semibold text-slate-800">{userData?.name || "N/A"}</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
                    <RiMailFill className="text-green-600 text-xl" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Email Address</p>
                    <p className="font-semibold text-slate-800">{userData?.userName || "N/A"}</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                    <RiPhoneFill className="text-purple-600 text-xl" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Mobile Number</p>
                    <p className="font-semibold text-slate-800">
                      {userData?.mobile && userData.mobile !== 0 ? userData.mobile : "Not provided"}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center">
                    <RiShieldUserFill className="text-orange-600 text-xl" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Role</p>
                    <p className="font-semibold text-slate-800 capitalize">{userData?.role || "N/A"}</p>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Actions Card */}
          <div>
            <Card sx={{ borderRadius: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.05)", p: 3 }}>
              <h3 className="text-lg font-bold text-slate-800 mb-4">Account Actions</h3>
              <div className="space-y-3">
                <button
                  onClick={logout}
                  className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
                >
                  <RiLogoutBoxRLine className="text-xl" />
                  Logout
                </button>
              </div>
            </Card>

            {/* Account Info */}
            <Card sx={{ borderRadius: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.05)", p: 3, mt: 3 }}>
              <h3 className="text-lg font-bold text-slate-800 mb-4">Account Info</h3>
              <div className="space-y-3">
                <div>
                  <p className="text-xs text-slate-500">User ID</p>
                  <p className="font-semibold text-slate-800">#{userData?.id || "N/A"}</p>
                </div>
                <div>
                  <p className="text-xs text-slate-500">Account Type</p>
                  <p className="font-semibold text-slate-800 capitalize">{userData?.role || "Standard"}</p>
                </div>
                <div>
                  <p className="text-xs text-slate-500">Status</p>
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Active
                  </span>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};
